// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-pages-Project-Settings-FollowUp-DynamicApprovalsEditor-___DynamicApprovalsEditor-module__container {
  display: flex;
  flex-direction: column;
}

.app-pages-Project-Settings-FollowUp-DynamicApprovalsEditor-___DynamicApprovalsEditor-module__subContainer {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  margin-top: 10px;
}

.app-pages-Project-Settings-FollowUp-DynamicApprovalsEditor-___DynamicApprovalsEditor-module__block {
  height: 250px;
  padding-left: 15px;
}

.app-pages-Project-Settings-FollowUp-DynamicApprovalsEditor-___DynamicApprovalsEditor-module__toolbar {
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  flex-wrap: nowrap;
}

.app-pages-Project-Settings-FollowUp-DynamicApprovalsEditor-___DynamicApprovalsEditor-module__scrollBlock {
  max-height: 250px;
  overflow-y: auto;
}

.app-pages-Project-Settings-FollowUp-DynamicApprovalsEditor-___DynamicApprovalsEditor-module__listItemContainer {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: space-between;
}

.app-pages-Project-Settings-FollowUp-DynamicApprovalsEditor-___DynamicApprovalsEditor-module__dynamicApprovalLabel {
  width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.app-pages-Project-Settings-FollowUp-DynamicApprovalsEditor-___DynamicApprovalsEditor-module__listItem__actionContainer {
  display: flex;
  flex-direction: row;
  align-items: center;
  align-content: center;
  flex-wrap: nowrap;
}

.app-pages-Project-Settings-FollowUp-DynamicApprovalsEditor-___DynamicApprovalsEditor-module__displayDynamicApprovalContainer {
  max-width: 270px;
  min-width: 270px;
  height: 250px;
  display: flex;
  flex-direction: column;
  position: relative;
  border-left: 1px solid lightgrey;
  padding-left: 10px;
}

.app-pages-Project-Settings-FollowUp-DynamicApprovalsEditor-___DynamicApprovalsEditor-module__dynamicApprovalInfo > :nth-child(1) {
  margin-right: 5px;
  font-weight: bold;
  white-space: nowrap;
}

.app-pages-Project-Settings-FollowUp-DynamicApprovalsEditor-___DynamicApprovalsEditor-module__dynamicApprovalInfo > :nth-child(2) {
  font-weight: normal;
}

.app-pages-Project-Settings-FollowUp-DynamicApprovalsEditor-___DynamicApprovalsEditor-module__iconButton {
  border-radius: 4px;
  color: var(--colors-black);
  margin: 0 2px;
  transition: 0.2s;
  cursor: pointer;
}

.app-pages-Project-Settings-FollowUp-DynamicApprovalsEditor-___DynamicApprovalsEditor-module__iconButtonSelected {
  background-color: none;
  color: #ffffff;
}

.app-pages-Project-Settings-FollowUp-DynamicApprovalsEditor-___DynamicApprovalsEditor-module__iconButton:hover {
  background-color: var(--colors-black);
  color: #ffffff;
}

.app-pages-Project-Settings-FollowUp-DynamicApprovalsEditor-___DynamicApprovalsEditor-module__noDynamicApprovalItem {
  width: 270px;
  height: 250px;
  display: flex;
  justify-content: center;
  align-items: center;
  align-content: center;
}
`, "",{"version":3,"sources":["webpack://./app/pages/Project/Settings/FollowUp/DynamicApprovalsEditor/DynamicApprovalsEditor.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,aAAa;EACb,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,qBAAqB;AACvB","sourcesContent":[".container {\n  display: flex;\n  flex-direction: column;\n}\n\n.subContainer {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  margin-top: 10px;\n}\n\n.block {\n  height: 250px;\n  padding-left: 15px;\n}\n\n.toolbar {\n  display: flex;\n  justify-content: space-between;\n  flex-direction: row;\n  flex-wrap: nowrap;\n}\n\n.scrollBlock {\n  max-height: 250px;\n  overflow-y: auto;\n}\n\n.listItemContainer {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.dynamicApprovalLabel {\n  width: 200px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.listItem__actionContainer {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  align-content: center;\n  flex-wrap: nowrap;\n}\n\n.displayDynamicApprovalContainer {\n  max-width: 270px;\n  min-width: 270px;\n  height: 250px;\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  border-left: 1px solid lightgrey;\n  padding-left: 10px;\n}\n\n.dynamicApprovalInfo > :nth-child(1) {\n  margin-right: 5px;\n  font-weight: bold;\n  white-space: nowrap;\n}\n\n.dynamicApprovalInfo > :nth-child(2) {\n  font-weight: normal;\n}\n\n.iconButton {\n  border-radius: 4px;\n  color: var(--colors-black);\n  margin: 0 2px;\n  transition: 0.2s;\n  cursor: pointer;\n}\n\n.iconButtonSelected {\n  background-color: none;\n  color: #ffffff;\n}\n\n.iconButton:hover {\n  background-color: var(--colors-black);\n  color: #ffffff;\n}\n\n.noDynamicApprovalItem {\n  width: 270px;\n  height: 250px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  align-content: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `app-pages-Project-Settings-FollowUp-DynamicApprovalsEditor-___DynamicApprovalsEditor-module__container`,
	"subContainer": `app-pages-Project-Settings-FollowUp-DynamicApprovalsEditor-___DynamicApprovalsEditor-module__subContainer`,
	"block": `app-pages-Project-Settings-FollowUp-DynamicApprovalsEditor-___DynamicApprovalsEditor-module__block`,
	"toolbar": `app-pages-Project-Settings-FollowUp-DynamicApprovalsEditor-___DynamicApprovalsEditor-module__toolbar`,
	"scrollBlock": `app-pages-Project-Settings-FollowUp-DynamicApprovalsEditor-___DynamicApprovalsEditor-module__scrollBlock`,
	"listItemContainer": `app-pages-Project-Settings-FollowUp-DynamicApprovalsEditor-___DynamicApprovalsEditor-module__listItemContainer`,
	"dynamicApprovalLabel": `app-pages-Project-Settings-FollowUp-DynamicApprovalsEditor-___DynamicApprovalsEditor-module__dynamicApprovalLabel`,
	"listItem__actionContainer": `app-pages-Project-Settings-FollowUp-DynamicApprovalsEditor-___DynamicApprovalsEditor-module__listItem__actionContainer`,
	"displayDynamicApprovalContainer": `app-pages-Project-Settings-FollowUp-DynamicApprovalsEditor-___DynamicApprovalsEditor-module__displayDynamicApprovalContainer`,
	"dynamicApprovalInfo": `app-pages-Project-Settings-FollowUp-DynamicApprovalsEditor-___DynamicApprovalsEditor-module__dynamicApprovalInfo`,
	"iconButton": `app-pages-Project-Settings-FollowUp-DynamicApprovalsEditor-___DynamicApprovalsEditor-module__iconButton`,
	"iconButtonSelected": `app-pages-Project-Settings-FollowUp-DynamicApprovalsEditor-___DynamicApprovalsEditor-module__iconButtonSelected`,
	"noDynamicApprovalItem": `app-pages-Project-Settings-FollowUp-DynamicApprovalsEditor-___DynamicApprovalsEditor-module__noDynamicApprovalItem`
};
export default ___CSS_LOADER_EXPORT___;
